/**
 * « Modifier mes informations » v2 (ProfileEdit.tsx) : corps de POST client/updateclient.
 *
 * Retour de Daphné du 07/10 : la case « informations importantes concernant mes réservations » (champ Mindbody
 * SendScheduleEmails : confirmations, rappels, annulations, liste d'attente) est retirée de l'écran, et le champ
 * n'est plus envoyé du tout. Le serveur (ClientService::updateClientInfo) ne le touche alors sur aucune fiche : sur
 * un site multi-marques, il écrit sinon la même valeur sur la fiche du client de chaque site de la ville. Renvoyer
 * la valeur du site courant (version du 07/10) recopiait un « non » de Dynamo sur RIISE et Punch (revue du 08/10).
 */
import type { MindbodyUser } from 'types/client';

export function profileUpdateBody(formData: Partial<MindbodyUser>): Partial<MindbodyUser> {
  const body: Partial<MindbodyUser> = { ...formData };
  delete body.SendScheduleEmails;
  return body;
}
